import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import styled from 'styled-components';

import { useCommunityInfoContext } from 'components/CommunityInfo/CommunityInfoContext';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ccc;
`;

const TableRow = styled.tr`
  border-bottom: 1px solid #ddd;
`;

const TableCell = styled.td`
  padding: 13px 20px;
`;

const TableCellContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const CommunityName = styled.div`
  font-size: 14px;
  font-weight: 900;
`;

const CompanyName = styled.div`
  font-size: 12px;
  font-weight: 500;
`;

const CommunityAddress = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: var(--text-secondary);
`;

const ChevronIcon = styled.img`
  width: 24px;
  height: 24px;
  cursor: pointer;
`;

const Link = styled.a`
  margin-top: 10px;
  color: var(--dark-blue);
  font-size: 14px;
  font-family: var(--font-regular);
`;

const CompetitorsTable = () => {
  const navigate = useNavigate();
  const { competitors } = useCommunityInfoContext();
  const [visibleCount, setVisibleCount] = useState(3);

  const visibleCompetitors = competitors?.slice(0, visibleCount) || [];

  const handleShowMore = () => {
    setVisibleCount((prev) => prev + 3);
  };

  if (!competitors || competitors.length === 0) {
    return <Container>No competitors available.</Container>;
  }

  return (
    <Container>
      <Table>
        <tbody>
          {visibleCompetitors.map((competitor, index) => (
            <TableRow key={index}>
              <TableCell>
                <TableCellContent>
                  <TextContainer>
                    <CommunityName>{competitor.comunity_name}</CommunityName>
                    <CompanyName>{competitor.company_name}</CompanyName>
                    <CommunityAddress>{competitor.address}</CommunityAddress>
                  </TextContainer>
                  <ChevronIcon
                    src="/icons/chevron-right.svg"
                    onClick={() => navigate(`/communities/${competitor.id}/info`)}
                  />
                </TableCellContent>
              </TableCell>
            </TableRow>
          ))}
        </tbody>
      </Table>

      {visibleCount < competitors.length && <Link onClick={handleShowMore}>Show More</Link>}
    </Container>
  );
};

export default CompetitorsTable;
